import { performPostRequest } from '@atlassian/jira-fetch';

const HAS_SEEN_NIN_CHANGEBOARDING_ADMIN_MODAL_QUERY = `
    query HasSeenNinChangeboardingAdminModalQuery {
        myPreferences(keys: [
            "jira.user.nin.changeboarding.admin-modal.viewed"
        ])
    }
`;

const fetchHasSeenNinChangeboardingAdminModal = async () => {
	const apiResult = await performPostRequest('/rest/gira/1/', {
		body: JSON.stringify({
			query: HAS_SEEN_NIN_CHANGEBOARDING_ADMIN_MODAL_QUERY,
		}),
	});

	const userPreferenceValue =
		apiResult.data.myPreferences['jira.user.nin.changeboarding.admin-modal.viewed'];
	if (
		userPreferenceValue !== 'true' &&
		userPreferenceValue !== 'false' &&
		userPreferenceValue !== null
	) {
		throw new RangeError('Unexpected user preference value');
	}

	return userPreferenceValue === 'true';
};

export default fetchHasSeenNinChangeboardingAdminModal;
